import CommonDialog from "../../CommonDialog/CommonDialog";
import { CreateOfferOrderForm } from "./CreateOfferOrderForm";
import { useState } from "react";
import {
    OrderFromOfferRequestDTO,
    OrderRequestDTO,
} from "../../../../explorer/types/OrderOffer/Order";
import { useFormFields } from "../../../hook/useFormfields";
import { useOfferOrder } from "../../../hook/useOfferOrder";
import ServiceProvider from "../../../configuration/ServiceProvider";
import { useTranslation } from "../../../../explorer/hooks/useTranslation";
import useBrands from "../../../../explorer/hooks/useBrands";
import { useApiError } from "../../../hook/useApiError";
import { OfferRequestDTO } from "../../../../explorer/types/OrderOffer/Offer";
import { ProgressPopup } from "../../../../explorer/components/ProgressPopup/ProgressPopup";
import { OrderOfferNotification } from "./OrderOfferNotification";
import { OrderFromOfferDTO } from "../../../../explorer/types/Basket/OfferDetailsResponse";
import { useApiPersistNotification } from "../../../hook/useApiPersistNotification";

export type DialogProps = {
    open: boolean;
    onClose: any;
    items: any;
    prices: any;
    currency?: string;
    showDiscount?: boolean;
    typeSubmit: "ORDER" | "OFFER" | "ORDER_FROM_OFFER";
    propsForOrder?: OrderFromOfferDTO;
};

export const BasketOfferOrderDialog = (props: DialogProps) => {
    const [progressPopupOpen, setProgressPopupOpen] = useState(false);
    const offerOfferOrder = useOfferOrder();
    const [error, setError] = useApiError();
    const [notification, setNotification] = useApiPersistNotification();

    const [ponValid, setPonValid] = useState(true);
    const [ponEmpty, setPonEmpty] = useState(false);
    const [ponBad, setPonBad] = useState(false);
    const [deliveryDateValid, setDeliveryDateValid] = useState(true);
    const [deliveryDateBad, setDeliveryDateBad] = useState(false);
    const [notificationPopupOpen, setNotificationPopupOpen] = useState(false);
    const [shipToAddressEmpty, setShipToAddressEmpty] = useState(false);
    const [serviceNotccepted, setServiceNotAccepted] = useState(false);
    const [deliveryDateEmpty, setDeliveryDateEmpty] = useState(false);

    const { t } = useTranslation();
    const brand = useBrands().currentBrandUrl;
   
   
    const isOrder= props.typeSubmit === "ORDER" || props.typeSubmit === "ORDER_FROM_OFFER" 
    const isOffer=!isOrder; //"OFFER"

    const {
        setFormFields,
        formFields,
        createChangeHandler,
        createChangeValueHandler,
    } = useFormFields({
        deliveryAddress: "",
        invoiceAddress: "",
        ponReference: "",
        partialShipment: true,
        note: "",
        deliveryDate: "",
        noteItems: {},
        hasAgreement: false,
        cgvAgreement:false,
        offerCode: "",
        customerOfferCode: "",
        sellingCompanyCode: "",
        currentLanguage: "",
        customerCode: "",
    });

    const handleClose = () => {
        props.onClose(false);
    };

    const handleOfferOrderSend = () => {
        var showErrorPopup: boolean = false;
        setPonEmpty(false);
        setPonBad(false);
        setShipToAddressEmpty(false);
        setServiceNotAccepted(false);
        setDeliveryDateEmpty(false);
        setDeliveryDateBad(false);

        if (formFields.ponReference == "") {
            showErrorPopup = true;
            setPonEmpty(true);
        } else if (ponValid == false) {
            showErrorPopup = true;
            setPonBad(true);
        }

        if (formFields.deliveryAddress == "") {
            setShipToAddressEmpty(true);
            showErrorPopup = true;
        }
        
        if (formFields.deliveryDate === undefined || formFields.deliveryDate ===null)
            {
                formFields.deliveryDate = "";
            }

        if (
            (isOrder) && 
            (formFields.deliveryDate === undefined ||
                formFields.deliveryDate === "")
        ) {
            //showErrorPopup = true;
            //setDeliveryDateEmpty(true);
        }

        if (
            (isOrder) && 
            (deliveryDateValid == false)
        ) {
            showErrorPopup = true;
            setDeliveryDateBad(true);
        }

        if (
            (isOrder) && (
            !formFields.hasAgreement
            || !formFields.cgvAgreement)
        ) {
            showErrorPopup = true;
            setServiceNotAccepted(true);
        }
        
        if (showErrorPopup) {
            setNotificationPopupOpen(true);
        } else {
            if (props.typeSubmit == "ORDER") {
                sendOrder();
            } else if (props.typeSubmit == "ORDER_FROM_OFFER") {
                sendOrderFromOffer();
            } else {
                sendOffer();
            }
        }
    };

    async function sendOffer() {
        setProgressPopupOpen(true);
        // aggiorno l'utente se lo shipTo è cambiato.

        const offerRequest: OfferRequestDTO = {
            DeliveryAddress: formFields.deliveryAddress,
            PonReference: formFields.ponReference,
            Note: formFields.note,
            PartialShipment: formFields.partialShipment,
            NoteItems: formFields.noteItems,
        };
        var result: any = await ServiceProvider.OrderOffer.sendOffer(
            brand,
            offerRequest
        )
            .then((result) => {
                setProgressPopupOpen(false);

                if (!result.hasError) {
                    props.onClose();
                    setNotification(
                        t("offer.sent").replace(
                            "#PON#",
                            result.customerOfferCode
                        )
                    );
                } else {
                    setError(result.message);
                }
            })
            .catch((error) => {
                setProgressPopupOpen(false);
                setError(error?.data?.title);
            });
    }

    async function sendOrderFromOffer() {
        setProgressPopupOpen(true);
        // aggiorno l'utente se lo shipTo è cambiato.

        const orderFromOfferRequest: OrderFromOfferRequestDTO = {
            OfferCode: formFields.offerCode,
            CustomerOfferCode: formFields.customerOfferCode,
            DeliveryAddress: formFields.deliveryAddress,
            PonReference: formFields.ponReference,
            DeliveryDate: formFields.deliveryDate,
            Note: formFields.note,
            PartialShipment: formFields.partialShipment,
            NoteItems: formFields.noteItems,
            SellingCompanyCode: formFields.sellingCompanyCode,
            CurrentLanguage: formFields.currentLanguage,
            CustomerCode: formFields.customerCode,
        };

        var result: any = await ServiceProvider.OrderOffer.sendOrderFromOffer(
            brand,
            orderFromOfferRequest
        )
            .then((result) => {
                setProgressPopupOpen(false);

                if (!result.hasError) {
                    props.onClose();
                    setNotification(
                        t("order.sent").replace(
                            "#PON#",
                            result.customerOrderCode
                        )
                    );
                } else {
                    setError(result.message);
                }
            })
            .catch((error) => {
                setProgressPopupOpen(false);
                setError(error?.data?.title);
            });
    }
    async function sendOrder() {
        setProgressPopupOpen(true);
        // aggiorno l'utente se lo shipTo è cambiato.

        const orderRequest: OrderRequestDTO = {
            DeliveryAddress: formFields.deliveryAddress,
            PonReference: formFields.ponReference,
            DeliveryDate: formFields.deliveryDate,
            Note: formFields.note,
            PartialShipment: formFields.partialShipment,
            NoteItems: formFields.noteItems,
        };

        var result: any = await ServiceProvider.OrderOffer.sendOrder(
            brand,
            orderRequest
        )
            .then((result) => {
                setProgressPopupOpen(false);

                if (!result.hasError) {
                    props.onClose();
                    setNotification(
                        t("order.sent").replace(
                            "#PON#",
                            result.customerOrderCode
                        )
                    );
                } else {
                    setError(result.message);
                }
            })
            .catch((error) => {
                setProgressPopupOpen(false);
                setError(error?.data?.title);
            });
    }

    return (
        <>
            <CommonDialog
                open={props.open}
                closeDialog={handleClose}
                dialogTitleLabel={isOffer ? "orderoffer.offer": "orderoffer.order"}
                useDenyBtn={true}
                useConfirmBtn={true}
                denyButtonText={"common.cancel"}
                confirmButtonText={"common.agree"}
                confirmButton={() => {
                    handleOfferOrderSend();
                }}
                maxWidth={"md"}
                children={
                    <>
                        <CreateOfferOrderForm
                            currency={props.currency}
                            showDiscount={props.showDiscount}
                            setFormFields={setFormFields}
                            formFields={formFields}
                            createChangeHandler={createChangeHandler}
                            createChangeValueHandler={createChangeValueHandler}
                            ponValid={ponValid}
                            setDeliveryDateValid={setDeliveryDateValid}
                            setPonValid={setPonValid}
                            prices={props.prices}
                            items={props.items}
                            typeSubmit={props.typeSubmit}
                            propsForOrder={props.propsForOrder}
                        />
                    </>
                }
            ></CommonDialog>
            <OrderOfferNotification
                ponEmpty={ponEmpty}
                ponBad={ponBad}
                shipToAddressEmpty={shipToAddressEmpty}
                deliveryDate={deliveryDateEmpty}
                deliveryDateBad={deliveryDateBad}
                notAccepted={serviceNotccepted}
                open={notificationPopupOpen}
                onClose={() => {
                    setNotificationPopupOpen(false);
                }}
                isOffer={isOffer}
            />
            <ProgressPopup
                open={progressPopupOpen}
                label={
                    (isOrder)
                        ? "orderoffer.order_sending"
                        : "orderoffer.offer_sending"
                }
            />
        </>
    );
};
